import React, {FC, PropsWithChildren, useMemo} from 'react';

import {EventStatus, GenericProps, MatchSimple, Sport, PeriodScore} from '../../utils/types';

import './styles.scss';

// BIQ: split this file & documentation

export interface MatchListItemProps extends GenericProps {
  match: MatchSimple;
}

interface MatchListItemWrapperProps extends GenericProps {
  id: string;
  slug: string;
}

// S24APP Usage


const MatchListItemWrapper: FC<PropsWithChildren<MatchListItemWrapperProps>> = ({
  id,
  slug,
  children,
  className,
}: PropsWithChildren<MatchListItemWrapperProps>) => {

  const isApp = useMemo(() => {
    return new URLSearchParams(window.location.search).has('sport24app');
  }, []);

  const isNews = useMemo(() => {
    return window.location.hostname.includes('news247.gr');
  }, []);

  const isExternal = isApp || isNews;

  return   id ? (
    <a href={isExternal
    ? `https://${window.location.hostname.includes('staging-wp') ? 'staging-wp' : 'www'}.sport24.gr/matchcenter/${slug}/${id}/${isApp ? '?sport24app=true' : ''}`
    : `/matchcenter/${slug}/${id}/`} className={`MatchListItem__wrapper ${className ?? ''}`} target='_blank' rel='noreferrer'>
      {children}
    </a>
  ) : (
    <div className={`MatchListItem__wrapper ${className ?? ''}`}>{children}</div>
  );
}

const MatchListItem: FC<MatchListItemProps> = ({
  match: {
    _id,
    sport,
    sportEventSlug,
    date,
    teams,
    liveBroadcast,
    status,
    minute,
    matchStatus,
    stoppageTime,
    score,
    periodScores,
  },
  className,
}: MatchListItemProps) => (
  <article
    className={`MatchListItem MatchListItem--${sport} ${
      status === EventStatus.LIVE ? 'MatchListItem--live' : ''
    } ${className ?? ''}`}
  >
    <MatchListItemWrapper className="MatchListItem__wrapper" id={_id} slug={sportEventSlug}>
      <div className="MatchListItem__header">
        {status === EventStatus.NOT_STARTED ? (
          <>
            <span className="MatchListItem__date">
              {date.getDate()} {date.toLocaleString('el-GR', {month: 'short'})}
            </span>
            <span className="MatchListItem__time">{`${date.getHours()}:${date
              .getMinutes()
              .toString()
              .padStart(2, '0')}`}</span>
          </>
        ) : (
          // <>
          //   <span className="MatchListItem__status">{matchStatus}</span>
          //   {
          //     /* eslint-disable no-nested-ternary */
          //     status === EventStatus.LIVE &&
          //       minute !== null &&
          //       minute !== undefined &&
          //       matchStatus !== 'ΗΜΙ' &&
          //       matchStatus !== 'BREAK' &&
          //       (matchStatus === '2 ΗΜ' && minute === 0 ? (
          //         <span className="MatchListItem__minute">45&apos;</span>
          //       ) : ['2η ΠΕΡ', '3η ΠΕΡ', '4η ΠΕΡ'].includes(matchStatus) && minute === 0 ? (
          //         <span className="MatchListItem__minute">
          //           {(parseInt(matchStatus.slice(0, 1), 10) - 1) * 10}&apos;
          //         </span>
          //       ) : (
          //         <span className="MatchListItem__minute">
          //           {minute}
          //           {stoppageTime ? ` + ${stoppageTime}` : ''}&apos;
          //         </span>
          //       ))
          //   }
          // </>
          <>
          <span className="MatchListItem__status">{matchStatus}</span>
          {status === EventStatus.LIVE &&
            minute !== null &&
            minute !== undefined &&
            minute !== 0 &&
            matchStatus !== 'ΗΜΙ' &&
            matchStatus !== "BREAK" && (
              <span className="MatchListItem__minute">{`${minute}'${
                stoppageTime ? ` + ${stoppageTime}` : ''
              }`}</span>
            )}
        </>
        )}
      </div>
      <div className="MatchListItem__content">
        <div
          className={`MatchListItem__team MatchListItem__team--home ${
            score[0] > score[1] ? 'MatchListItem__team--winning' : ''
          }`}
        >
          <span className="MatchListItem__teamName">{teams[0].name}</span>
          <span className="MatchListItem__teamScore">
            {status === EventStatus.NOT_STARTED ? '-' : score[0]}
          </span>
        </div>

        <div
          className={`MatchListItem__team MatchListItem__team--away ${
            score[0] < score[1] ? 'MatchListItem__team--winning' : ''
          }`}
        >
          <span className="MatchListItem__teamName">{teams[1].name}</span>
          <span className="MatchListItem__teamScore">
            {status === EventStatus.NOT_STARTED ? '-' : score[1]}
          </span>
        </div>
        {liveBroadcast?.activity === true && <div className="MatchListItem__broadcast">
          <svg xmlns="http://www.w3.org/2000/svg" width="12.75" height="10" viewBox="0 0 12.75 10"><g data-name="Group 7949"><g data-name="Group 7939" fill="#ff0040"><path data-name="Path 2502" d="M6.25 9.998v-10l-6.25 5Z"/><path data-name="Rectangle 4810" d="M0 3.125h3.75v3.75H0z"/></g><g data-name="Group 7947" fill="none" stroke="#ff0040"><path data-name="Path 2506" d="M8.252 1.004a4 4 0 0 1 0 8"/><path data-name="Path 2507" d="M8.252 3.004a2 2 0 0 1 0 4"/></g></g></svg>
          <span>ΗΧΗΤΙΚΗ ΜΕΤΑΔΟΣΗ</span>
          </div>}
      </div>
    </MatchListItemWrapper>
  </article>
);

export default MatchListItem;
